import { render, staticRenderFns } from "./vender-modulr-edit-form.vue?vue&type=template&id=84e0d784&"
import script from "./vender-modulr-edit-form.vue?vue&type=script&lang=js&"
export * from "./vender-modulr-edit-form.vue?vue&type=script&lang=js&"
import style0 from "./vender-modulr-edit-form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports